// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowCard-cls1_Hql","cls2":"BulkFollowCard-cls2_E_f BulkFollowCard-cls1_Hql"};